import { Button, useDisclosure } from '@chakra-ui/react'
import { Add } from 'src/components/icon'
import { useSpinner } from 'src/hooks/use-spinner'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'
import {
  CreateExplanationReservationDocument,
  ExplanationType,
} from 'src/lib/gql-client'
import { useGqlMutation } from 'src/lib/gql-client/request'

import { EditReservationModal } from '../EditReservationModal/EditReservationModal'

type Props = {
  explanationRevisionUid: string
  explanationType: ExplanationType
  isPartnerMemberNotAssigned?: boolean
  isAgreementCompleted: boolean
  partnerHospitalName: string | undefined
  mutateExplanation: () => void
}

export const CreateReservationButton: React.FC<Props> = ({
  explanationRevisionUid,
  explanationType,
  isPartnerMemberNotAssigned,
  isAgreementCompleted,
  partnerHospitalName,
  mutateExplanation,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const toast = useMirohaToast()

  const { showSpinner, hideSpinner } = useSpinner()

  const { request: createReservation } = useGqlMutation(
    CreateExplanationReservationDocument,
    {
      onRequestStarted: showSpinner,
      onRequestDone: hideSpinner,
      onSuccess: () => {
        onClose()
        mutateExplanation()

        const toastDescription = isAgreementCompleted
          ? 'ご予約のお時間に「ビデオ通話を開始」より面談を実施してください。'
          : 'ご予約のお時間に「説明ロビーへ」より面談を実施してください。'
        toast({
          status: 'success',
          title: '次回面談情報を送信しました。',
          description: toastDescription,
        })
      },
    },
  )

  return (
    <>
      <Button onClick={onOpen} variant="text" leftIcon={<Add />}>
        面談予約登録
      </Button>

      <EditReservationModal
        isOpen={isOpen}
        formType="new"
        key={isOpen ? 'open' : 'close'} // 開いた時に初期値を設定するためにkeyを設定
        explanationType={explanationType}
        isAgreementCompleted={isAgreementCompleted}
        isPartnerMemberNotAssigned={isPartnerMemberNotAssigned ?? false}
        partnerHospitalName={partnerHospitalName}
        onClose={onClose}
        onSubmit={async value => {
          await createReservation({
            input: {
              explanationRevisionUid,
              reservationType: null,
              reservationInviteeType: value.inviteeType,
              reservedAt: value.reservedAt,
            },
          })
        }}
      />
    </>
  )
}
